(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var listOf = kotlin_kotlin.$_$.b;
  var protoOf = kotlin_kotlin.$_$.f;
  var classMeta = kotlin_kotlin.$_$.c;
  var VOID = kotlin_kotlin.$_$.h;
  var setMetadataFor = kotlin_kotlin.$_$.g;
  var objectMeta = kotlin_kotlin.$_$.e;
  var defineProp = kotlin_kotlin.$_$.d;
  var copyToArray = kotlin_kotlin.$_$.a;
  //endregion
  //region block: pre-declaration
  setMetadataFor(GetAllColorsUseCase, 'GetAllColorsUseCase', classMeta);
  setMetadataFor(GetColorByHexCodeUseCase, 'GetColorByHexCodeUseCase', classMeta);
  setMetadataFor(Group, 'Group', classMeta);
  setMetadataFor(Gray, 'Gray', objectMeta, Group);
  setMetadataFor(White, 'White', objectMeta, Group);
  setMetadataFor(Brown, 'Brown', objectMeta, Group);
  setMetadataFor(Blue, 'Blue', objectMeta, Group);
  setMetadataFor(Green, 'Green', objectMeta, Group);
  setMetadataFor(Purple, 'Purple', objectMeta, Group);
  setMetadataFor(Yellow, 'Yellow', objectMeta, Group);
  setMetadataFor(Orange, 'Orange', objectMeta, Group);
  setMetadataFor(Pink, 'Pink', objectMeta, Group);
  setMetadataFor(Red, 'Red', objectMeta, Group);
  setMetadataFor(Unknown, 'Unknown', objectMeta, Group);
  setMetadataFor(Color, 'Color', classMeta);
  setMetadataFor(Black, 'Black', classMeta, Color);
  setMetadataFor(DarkSlateGrey, 'DarkSlateGrey', classMeta, Color);
  setMetadataFor(Grey, 'Grey', classMeta, Color);
  setMetadataFor(DarkGray, 'DarkGray', classMeta, Color);
  setMetadataFor(LightGrey, 'LightGrey', classMeta, Color);
  setMetadataFor(Silver, 'Silver', classMeta, Color);
  setMetadataFor(White_0, 'White', classMeta, Color);
  setMetadataFor(LightCyan, 'LightCyan', classMeta, Color);
  setMetadataFor(Beige, 'Beige', classMeta, Color);
  setMetadataFor(Maroon, 'Maroon', classMeta, Color);
  setMetadataFor(Sienna, 'Sienna', classMeta, Color);
  setMetadataFor(Brown_0, 'Brown', classMeta, Color);
  setMetadataFor(Chocolate, 'Chocolate', classMeta, Color);
  setMetadataFor(SandyBrown, 'SandyBrown', classMeta, Color);
  setMetadataFor(Bronze, 'Bronze', classMeta, Color);
  setMetadataFor(BurlyWood, 'BurlyWood', classMeta, Color);
  setMetadataFor(Kashmir, 'Kashmir', classMeta, Color);
  setMetadataFor(Creamy, 'Creamy', classMeta, Color);
  setMetadataFor(PrussianBlue, 'PrussianBlue', classMeta, Color);
  setMetadataFor(Navy, 'Navy', classMeta, Color);
  setMetadataFor(DarkBlue, 'DarkBlue', classMeta, Color);
  setMetadataFor(Blue_0, 'Blue', classMeta, Color);
  setMetadataFor(MediumSlateBlue, 'MediumSlateBlue', classMeta, Color);
  setMetadataFor(DodgerBlue, 'DodgerBlue', classMeta, Color);
  setMetadataFor(DeepSkyBlue, 'DeepSkyBlue', classMeta, Color);
  setMetadataFor(SkyBlue, 'SkyBlue', classMeta, Color);
  setMetadataFor(SteelBlue, 'SteelBlue', classMeta, Color);
  setMetadataFor(CadetBlue, 'CadetBlue', classMeta, Color);
  setMetadataFor(Turquoise, 'Turquoise', classMeta, Color);
  setMetadataFor(PaleTurquoise, 'PaleTurquoise', classMeta, Color);
  setMetadataFor(Aqua, 'Aqua', classMeta, Color);
  setMetadataFor(DarkCyan, 'DarkCyan', classMeta, Color);
  setMetadataFor(DarkOliveGreen, 'DarkOliveGreen', classMeta, Color);
  setMetadataFor(Olive, 'Olive', classMeta, Color);
  setMetadataFor(DarkGreen, 'DarkGreen', classMeta, Color);
  setMetadataFor(Green_0, 'Green', classMeta, Color);
  setMetadataFor(SeaGreen, 'SeaGreen', classMeta, Color);
  setMetadataFor(SpringGreen, 'SpringGreen', classMeta, Color);
  setMetadataFor(LightGreen, 'LightGreen', classMeta, Color);
  setMetadataFor(LimeGreen, 'LimeGreen', classMeta, Color);
  setMetadataFor(Lime, 'Lime', classMeta, Color);
  setMetadataFor(GreenYellow, 'GreenYellow', classMeta, Color);
  setMetadataFor(DarkSlateBlue, 'DarkSlateBlue', classMeta, Color);
  setMetadataFor(Indigo, 'Indigo', classMeta, Color);
  setMetadataFor(Purple_0, 'Purple', classMeta, Color);
  setMetadataFor(Amethyst, 'Amethyst', classMeta, Color);
  setMetadataFor(MediumOrchid, 'MediumOrchid', classMeta, Color);
  setMetadataFor(Violet, 'Violet', classMeta, Color);
  setMetadataFor(Mauve, 'Mauve', classMeta, Color);
  setMetadataFor(Lavender, 'Lavender', classMeta, Color);
  setMetadataFor(DarkKhaki, 'DarkKhaki', classMeta, Color);
  setMetadataFor(Khaki, 'Khaki', classMeta, Color);
  setMetadataFor(LightYellow, 'LightYellow', classMeta, Color);
  setMetadataFor(Yellow_0, 'Yellow', classMeta, Color);
  setMetadataFor(Gold, 'Gold', classMeta, Color);
  setMetadataFor(Rust, 'Rust', classMeta, Color);
  setMetadataFor(Persimmon, 'Persimmon', classMeta, Color);
  setMetadataFor(Orange_0, 'Orange', classMeta, Color);
  setMetadataFor(DarkOrange, 'DarkOrange', classMeta, Color);
  setMetadataFor(OrangeRed, 'OrangeRed', classMeta, Color);
  setMetadataFor(Tomato, 'Tomato', classMeta, Color);
  setMetadataFor(Coral, 'Coral', classMeta, Color);
  setMetadataFor(LightSalmon, 'LightSalmon', classMeta, Color);
  setMetadataFor(PaleVioletRed, 'PaleVioletRed', classMeta, Color);
  setMetadataFor(MediumVioletRed, 'MediumVioletRed', classMeta, Color);
  setMetadataFor(Fuchsia, 'Fuchsia', classMeta, Color);
  setMetadataFor(Cardinal, 'Cardinal', classMeta, Color);
  setMetadataFor(Ruby, 'Ruby', classMeta, Color);
  setMetadataFor(DarkPink, 'DarkPink', classMeta, Color);
  setMetadataFor(DeepPink, 'DeepPink', classMeta, Color);
  setMetadataFor(HotPink, 'HotPink', classMeta, Color);
  setMetadataFor(Pink_0, 'Pink', classMeta, Color);
  setMetadataFor(DarkRed, 'DarkRed', classMeta, Color);
  setMetadataFor(FireBrick, 'FireBrick', classMeta, Color);
  setMetadataFor(Red_0, 'Red', classMeta, Color);
  setMetadataFor(Salmon, 'Salmon', classMeta, Color);
  setMetadataFor(LightCoral, 'LightCoral', classMeta, Color);
  setMetadataFor(IndianRed, 'IndianRed', classMeta, Color);
  setMetadataFor(AnyColor, 'AnyColor', classMeta, Color);
  //endregion
  function GetAllColorsUseCase() {
  }
  protoOf(GetAllColorsUseCase).s1 = function () {
    return listOf([new Black(), new DarkSlateGrey(), new Grey(), new DarkGray(), new LightGrey(), new Silver(), new White_0(), new LightCyan(), new Beige(), new Maroon(), new Sienna(), new Brown_0(), new Chocolate(), new SandyBrown(), new Bronze(), new BurlyWood(), new Kashmir(), new Creamy(), new PrussianBlue(), new Navy(), new DarkBlue(), new Blue_0(), new MediumSlateBlue(), new DodgerBlue(), new DeepSkyBlue(), new SkyBlue(), new SteelBlue(), new CadetBlue(), new Turquoise(), new PaleTurquoise(), new Aqua(), new DarkCyan(), new DarkOliveGreen(), new Olive(), new DarkGreen(), new Green_0(), new SeaGreen(), new SpringGreen(), new LightGreen(), new LimeGreen(), new Lime(), new GreenYellow(), new DarkSlateBlue(), new Indigo(), new Purple_0(), new Amethyst(), new MediumOrchid(), new Violet(), new Mauve(), new Lavender(), new DarkKhaki(), new Khaki(), new LightYellow(), new Yellow_0(), new Gold(), new Rust(), new Persimmon(), new Orange_0(), new DarkOrange(), new OrangeRed(), new Tomato(), new Coral(), new LightSalmon(), new PaleVioletRed(), new MediumVioletRed(), new Fuchsia(), new Cardinal(), new Ruby(), new DarkPink(), new DeepPink(), new HotPink(), new Pink_0(), new DarkRed(), new FireBrick(), new Red_0(), new LightSalmon(), new Salmon(), new LightCoral(), new IndianRed()]);
  };
  function GetColorByHexCodeUseCase() {
  }
  protoOf(GetColorByHexCodeUseCase).t1 = function (hexCode) {
    var colors = (new GetAllColorsUseCase()).s1();
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = colors.b();
      while (tmp0_iterator.c()) {
        var element = tmp0_iterator.d();
        // Inline function 'com.taager.variants.GetColorByHexCodeUseCase.invoke.<anonymous>' call
        if (element.hexValue === hexCode) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? new AnyColor(hexCode) : tmp0_elvis_lhs;
  };
  function Gray() {
    Gray_instance = this;
    Group.call(this, 'Gray', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0631\u0645\u0627\u062F\u064A\u0629');
  }
  var Gray_instance;
  function Gray_getInstance() {
    if (Gray_instance == null)
      new Gray();
    return Gray_instance;
  }
  function White() {
    White_instance = this;
    Group.call(this, 'White', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0628\u064A\u0636\u0627\u0621');
  }
  var White_instance;
  function White_getInstance() {
    if (White_instance == null)
      new White();
    return White_instance;
  }
  function Brown() {
    Brown_instance = this;
    Group.call(this, 'Brown', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0633\u0645\u0631\u0627\u0621 (\u0627\u0644\u0628\u0646\u064A)');
  }
  var Brown_instance;
  function Brown_getInstance() {
    if (Brown_instance == null)
      new Brown();
    return Brown_instance;
  }
  function Blue() {
    Blue_instance = this;
    Group.call(this, 'Blue', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0632\u0631\u0642\u0627\u0621');
  }
  var Blue_instance;
  function Blue_getInstance() {
    if (Blue_instance == null)
      new Blue();
    return Blue_instance;
  }
  function Green() {
    Green_instance = this;
    Group.call(this, 'Green', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u062E\u0636\u0631\u0627\u0621');
  }
  var Green_instance;
  function Green_getInstance() {
    if (Green_instance == null)
      new Green();
    return Green_instance;
  }
  function Purple() {
    Purple_instance = this;
    Group.call(this, 'Purple', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0623\u0631\u062C\u0648\u0627\u0646\u064A\u0629');
  }
  var Purple_instance;
  function Purple_getInstance() {
    if (Purple_instance == null)
      new Purple();
    return Purple_instance;
  }
  function Yellow() {
    Yellow_instance = this;
    Group.call(this, 'Yellow', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u0631\u0627\u0621');
  }
  var Yellow_instance;
  function Yellow_getInstance() {
    if (Yellow_instance == null)
      new Yellow();
    return Yellow_instance;
  }
  function Orange() {
    Orange_instance = this;
    Group.call(this, 'Orange', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u062A\u0642\u0627\u0644\u064A\u0629');
  }
  var Orange_instance;
  function Orange_getInstance() {
    if (Orange_instance == null)
      new Orange();
    return Orange_instance;
  }
  function Pink() {
    Pink_instance = this;
    Group.call(this, 'Pink', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u0642\u0631\u0646\u0641\u0644\u064A\u0629');
  }
  var Pink_instance;
  function Pink_getInstance() {
    if (Pink_instance == null)
      new Pink();
    return Pink_instance;
  }
  function Red() {
    Red_instance = this;
    Group.call(this, 'Red', '\u0627\u0644\u0623\u0644\u0648\u0627\u0646 \u0627\u0644\u062D\u0645\u0631\u0627\u0621');
  }
  var Red_instance;
  function Red_getInstance() {
    if (Red_instance == null)
      new Red();
    return Red_instance;
  }
  function Unknown() {
    Unknown_instance = this;
    Group.call(this, '', '');
  }
  var Unknown_instance;
  function Unknown_getInstance() {
    if (Unknown_instance == null)
      new Unknown();
    return Unknown_instance;
  }
  function Group(englishName, arabicName) {
    this.englishName = englishName;
    this.arabicName = arabicName;
  }
  protoOf(Group).u1 = function () {
    return this.englishName;
  };
  protoOf(Group).v1 = function () {
    return this.arabicName;
  };
  function Color(group, englishName, arabicName, hexValue) {
    this.group = group;
    this.englishName = englishName;
    this.arabicName = arabicName;
    this.hexValue = hexValue;
  }
  protoOf(Color).w1 = function () {
    return this.group;
  };
  protoOf(Color).u1 = function () {
    return this.englishName;
  };
  protoOf(Color).v1 = function () {
    return this.arabicName;
  };
  protoOf(Color).x1 = function () {
    return this.hexValue;
  };
  function Black() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Black', '\u0623\u0633\u0648\u062F', '#000000');
  }
  function DarkSlateGrey() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Dark Slate Grey', '\u0631\u0645\u0627\u062F\u064A \u0634\u0627\u062D\u0628 \u063A\u0627\u0645\u0642', '#2f4f4f');
  }
  function Grey() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Grey', '\u0631\u0645\u0627\u062F\u064A', '#808080');
  }
  function DarkGray() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Dark Gray', '\u0631\u0645\u0627\u062F\u064A \u063A\u0627\u0645\u0642', '#a9a9a9');
  }
  function LightGrey() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Light Grey', '\u0631\u0645\u0627\u062F\u064A \u0641\u0627\u062A\u062D', '#d3d3d3');
  }
  function Silver() {
    var tmp0_group = Gray_getInstance();
    Color.call(this, tmp0_group, 'Silver', '\u0641\u0636\u064A', '#c0c0c0');
  }
  function White_0() {
    var tmp0_group = White_getInstance();
    Color.call(this, tmp0_group, 'White', '\u0623\u0628\u064A\u0636', '#ffffff');
  }
  function LightCyan() {
    var tmp0_group = White_getInstance();
    Color.call(this, tmp0_group, 'Light Cyan', '\u0627\u0632\u0631\u0642 \u0633\u0645\u0627\u0648\u064A \u0641\u0627\u062A\u062D', '#e0ffff');
  }
  function Beige() {
    var tmp0_group = White_getInstance();
    Color.call(this, tmp0_group, 'Beige', '\u0627\u0644\u0628\u064A\u062C', '#f5f5dc');
  }
  function Maroon() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Maroon', '\u0645\u0627\u0631\u0648\u0646\u064A', '#800000');
  }
  function Sienna() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Sienna', '\u0633\u064A\u064A\u0646\u0627', '#a0522d');
  }
  function Brown_0() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Brown', '\u0628\u0646\u064A', '#8b4513');
  }
  function Chocolate() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Chocolate', '\u0634\u064A\u0643\u0648\u0644\u0627\u062A\u0629', '#d2691e');
  }
  function SandyBrown() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Sandy Brown', '\u0628\u0646\u064A \u0631\u0645\u0644\u064A', '#f4a460');
  }
  function Bronze() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Bronze', '\u0646\u062D\u0627\u0633\u064A', '#dca270');
  }
  function BurlyWood() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Burly Wood', '\u062E\u0634\u0628\u064A', '#deb887');
  }
  function Kashmir() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Kashmir', '\u0643\u0634\u0645\u064A\u0631', '#ccae94');
  }
  function Creamy() {
    var tmp0_group = Brown_getInstance();
    Color.call(this, tmp0_group, 'Creamy', '\u0643\u0631\u064A\u0645\u064A', '#fffdd0');
  }
  function PrussianBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Prussian Blue', '\u0643\u062D\u0644\u064A \u063A\u0627\u0645\u0642', '#000033');
  }
  function Navy() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Navy', '\u0643\u062D\u0644\u064A', '#000066');
  }
  function DarkBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Dark Blue', '\u0623\u0632\u0631\u0642 \u063A\u0627\u0645\u0642', '#00008b');
  }
  function Blue_0() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Blue', '\u0623\u0632\u0631\u0642', '#0000ff');
  }
  function MediumSlateBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Medium Slate Blue', '\u0623\u0632\u0631\u0642 \u0631\u0645\u0627\u062F\u064A \u0645\u062A\u0648\u0633\u0637', '#7b68ee');
  }
  function DodgerBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Dodger Blue', '\u0623\u0632\u0631\u0642 \u0645\u0631\u0627\u0648\u063A', '#1e90ff');
  }
  function DeepSkyBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Deep Sky Blue', '\u0627\u0632\u0631\u0642 \u0633\u0645\u0627\u0648\u064A \u0639\u0645\u064A\u0642', '#00bfff');
  }
  function SkyBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Sky Blue', '\u0627\u0632\u0631\u0642 \u0633\u0645\u0627\u0648\u064A', '#87ceeb');
  }
  function SteelBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Steel Blue', '\u0627\u0632\u0631\u0642 \u0631\u0645\u0627\u062F\u064A', '#4682b4');
  }
  function CadetBlue() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Cadet Blue', '\u0627\u0632\u0631\u0642 \u0643\u0627\u062F\u064A\u062A', '#5f9ea0');
  }
  function Turquoise() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Turquoise', '\u0641\u064A\u0631\u0648\u0632\u064A', '#40e0d0');
  }
  function PaleTurquoise() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Pale Turquoise', '\u062A\u0631\u0643\u0648\u0627\u0632 \u0634\u0627\u062D\u0628', '#afeeee');
  }
  function Aqua() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Aqua', '\u0633\u0645\u0627\u0648\u064A', '#00ffff');
  }
  function DarkCyan() {
    var tmp0_group = Blue_getInstance();
    Color.call(this, tmp0_group, 'Dark Cyan', '\u0633\u0645\u0627\u0648\u064A \u063A\u0627\u0645\u0642', '#008b8b');
  }
  function DarkOliveGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Dark Olive Green', '\u0627\u062E\u0636\u0631 \u0632\u064A\u062A\u0648\u0646\u064A \u063A\u0627\u0645\u0642', '#556b2f');
  }
  function Olive() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Olive', '\u0632\u064A\u062A\u0648\u0646\u064A', '#808000');
  }
  function DarkGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Dark Green', '\u0627\u062E\u0636\u0631 \u063A\u0627\u0645\u0642', '#006400');
  }
  function Green_0() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Green', '\u0623\u062E\u0636\u0631', '#008000');
  }
  function SeaGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Sea Green', '\u0627\u062E\u0636\u0631 \u0628\u062D\u0631\u064A', '#2e8b57');
  }
  function SpringGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Spring Green', '\u0627\u062E\u0636\u0631 \u0631\u0628\u064A\u0639\u064A', '#00ff7f');
  }
  function LightGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Light Green', '\u0623\u062E\u0636\u0631 \u0641\u0627\u062A\u062D', '#90ee90');
  }
  function LimeGreen() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Lime Green', '\u0627\u062E\u0636\u0631 \u0644\u064A\u0645\u0648\u0646\u064A', '#32cd32');
  }
  function Lime() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Lime', '\u0644\u064A\u0645\u0648\u0646\u064A', '#00ff00');
  }
  function GreenYellow() {
    var tmp0_group = Green_getInstance();
    Color.call(this, tmp0_group, 'Green Yellow', '\u0623\u0635\u0641\u0631 \u0645\u062E\u0636\u0631', '#adff2f');
  }
  function DarkSlateBlue() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Dark Slate Blue', '\u0627\u0632\u0631\u0642 \u0634\u0627\u062D\u0628 \u063A\u0627\u0645\u0642', '#483d8b');
  }
  function Indigo() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Indigo', '\u0646\u064A\u0644\u064A', '#4b0082');
  }
  function Purple_0() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Purple', '\u0623\u062D\u0645\u0631 \u0627\u0631\u062C\u0648\u0627\u0646\u064A', '#800080');
  }
  function Amethyst() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Amethyst', '\u0627\u0648\u0631\u0643\u064A\u062F\u064A \u063A\u0627\u0645\u0642', '#9966cc');
  }
  function MediumOrchid() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Medium Orchid', '\u0627\u0648\u0631\u0643\u064A\u062F\u064A \u0645\u0639\u062A\u062F\u0644', '#ba55d3');
  }
  function Violet() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Violet', '\u0627\u0644\u0628\u0646\u0641\u0633\u062C\u0649', '#ee82ee');
  }
  function Mauve() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Mauve', '\u0628\u0646\u0641\u0633\u062C\u064A \u0641\u0627\u062A\u062D', '#cc99ff');
  }
  function Lavender() {
    var tmp0_group = Purple_getInstance();
    Color.call(this, tmp0_group, 'Lavender', '\u0627\u0644\u0644\u0627\u0641\u0646\u062F\u0631', '#e6e6fa');
  }
  function DarkKhaki() {
    var tmp0_group = Yellow_getInstance();
    Color.call(this, tmp0_group, 'Dark Khaki', '\u0643\u0627\u0643\u064A \u063A\u0627\u0645\u0642', '#bdb76b');
  }
  function Khaki() {
    var tmp0_group = Yellow_getInstance();
    Color.call(this, tmp0_group, 'Khaki', '\u0643\u0627\u0643\u064A', '#f0e68c');
  }
  function LightYellow() {
    var tmp0_group = Yellow_getInstance();
    Color.call(this, tmp0_group, 'Light Yellow', '\u0623\u0635\u0641\u0631 \u0641\u0627\u062A\u062D', '#ffffe0');
  }
  function Yellow_0() {
    var tmp0_group = Yellow_getInstance();
    Color.call(this, tmp0_group, 'Yellow', '\u0623\u0635\u0641\u0631', '#ffff00');
  }
  function Gold() {
    var tmp0_group = Yellow_getInstance();
    Color.call(this, tmp0_group, 'Gold', '\u0630\u0647\u0628\u064A', '#ffd700');
  }
  function Rust() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Rust', '\u0631\u0633\u062A\u064A', '#bf360c');
  }
  function Persimmon() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Persimmon', '\u0628\u0631\u0633\u064A\u0645\u0648\u0646', '#e65100');
  }
  function Orange_0() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Orange', '\u0628\u0631\u062A\u0642\u0627\u0644\u064A', '#ffa500');
  }
  function DarkOrange() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Dark Orange', '\u0628\u0631\u062A\u0642\u0627\u0644\u064A \u063A\u0627\u0645\u0642', '#ff8c00');
  }
  function OrangeRed() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Orange Red', '\u0623\u062D\u0645\u0631 \u0628\u0631\u062A\u0642\u0627\u0644\u064A', '#ff4500');
  }
  function Tomato() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Tomato', '\u0637\u0645\u0627\u0637\u0645\u064A', '#ff6347');
  }
  function Coral() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Coral', '\u0645\u0631\u062C\u0627\u0646\u064A', '#ff7f50');
  }
  function LightSalmon() {
    var tmp0_group = Orange_getInstance();
    Color.call(this, tmp0_group, 'Light Salmon', '\u0633\u0644\u0645\u0648\u0646\u064A \u0641\u0627\u062A\u062D', '#ffa07a');
  }
  function PaleVioletRed() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Pale Violet Red', '\u0627\u062D\u0645\u0631 \u0628\u0646\u0641\u0633\u062C\u064A \u0628\u0627\u0647\u062A', '#db7093');
  }
  function MediumVioletRed() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Medium Violet Red', '\u0627\u062D\u0645\u0631 \u0628\u0646\u0641\u0633\u062C\u064A \u0645\u0639\u062A\u062F\u0644', '#c71585');
  }
  function Fuchsia() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Fuchsia', '\u0641\u0648\u0634\u064A\u0627', '#ff00ff');
  }
  function Cardinal() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Cardinal', '\u0643\u0627\u0631\u062F\u064A\u0646\u0627\u0644', '#c2185b');
  }
  function Ruby() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Ruby', '\u0631\u0648\u0628\u064A', '#e91e63');
  }
  function DarkPink() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Dark Pink', '\u0648\u0631\u062F\u064A \u063A\u0627\u0645\u0642', '#f06292');
  }
  function DeepPink() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Deep Pink', '\u0648\u0631\u062F\u064A \u0639\u0645\u064A\u0642', '#ff1493');
  }
  function HotPink() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Hot Pink', '\u0648\u0631\u062F\u064A \u0635\u0627\u0631\u062E', '#ff69b4');
  }
  function Pink_0() {
    var tmp0_group = Pink_getInstance();
    Color.call(this, tmp0_group, 'Pink', '\u0648\u0631\u062F\u0649', '#ffc0cb');
  }
  function DarkRed() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Dark Red', '\u0623\u062D\u0645\u0631 \u063A\u0627\u0645\u0642', '#8b0000');
  }
  function FireBrick() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Fire Brick', '\u0637\u0648\u0628\u064A', '#b22222');
  }
  function Red_0() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Red', '\u0623\u062D\u0645\u0631', '#ff0000');
  }
  function Salmon() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Salmon', '\u0633\u0644\u0645\u0648\u0646\u064A', '#fa8072');
  }
  function LightCoral() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Light Coral', '\u0645\u0631\u062C\u0627\u0646\u064A \u0641\u0627\u062A\u062D', '#f08080');
  }
  function IndianRed() {
    var tmp0_group = Red_getInstance();
    Color.call(this, tmp0_group, 'Indian Red', '\u0623\u062D\u0645\u0631 \u0647\u0646\u062F\u064A', '#cd5c5c');
  }
  function AnyColor(hexValue) {
    var tmp0_group = Unknown_getInstance();
    Color.call(this, tmp0_group, '', '', hexValue);
  }
  function getAllColorsUseCase() {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp0_toTypedArray = (new GetAllColorsUseCase()).s1();
    return copyToArray(tmp0_toTypedArray);
  }
  function getColorByHexCode(hexValue) {
    return (new GetColorByHexCodeUseCase()).t1(hexValue);
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$variants = $com$taager.variants || ($com$taager.variants = {});
    var $com$taager$variants$model = $com$taager$variants.model || ($com$taager$variants.model = {});
    $com$taager$variants$model.Color = Color;
    $com$taager$variants$model.Color.Group = Group;
    defineProp($com$taager$variants$model.Color.Group, 'Gray', Gray_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'White', White_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Brown', Brown_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Blue', Blue_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Green', Green_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Purple', Purple_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Yellow', Yellow_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Orange', Orange_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Pink', Pink_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Red', Red_getInstance, VOID);
    defineProp($com$taager$variants$model.Color.Group, 'Unknown', Unknown_getInstance, VOID);
    _.getAllColorsUseCase = getAllColorsUseCase;
    _.getColorByHexCode = getColorByHexCode;
  }
  $jsExportAll$(_);
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js')));

